/**
 * Modal view script: open/close functionality.
 */
( function () {
	const MODAL_OPEN_CLASS = 'wps-blocks-modal--open';
	const BODY_LOCK_CLASS = 'wps-blocks-body--modal-open';

	class WpsBlocksModalManager {
		constructor() {
			this.activeModals = new Set();
			this.init();
		}

		init() {
			document.addEventListener(
				'click',
				this.handleTriggerClick.bind( this )
			);
			document.addEventListener(
				'keydown',
				this.handleEscapeKey.bind( this )
			);
		}

		handleTriggerClick( event ) {
			const trigger = event.target.closest( '[data-modal-trigger]' );
			if ( trigger ) {
				event.preventDefault();
				const modalId = trigger.getAttribute( 'data-modal-trigger' );
				this.openModal( modalId );
				return;
			}

			const closeBtn = event.target.closest( '[data-modal-close]' );
			if ( closeBtn ) {
				const modal = closeBtn.closest( '.wp-block-wps-blocks-modal' );
				if ( modal ) {
					event.preventDefault();
					this.closeModal( modal );
				}
				return;
			}

			if (
				event.target.classList.contains( 'wp-block-wps-blocks-modal' )
			) {
				const modal = event.target;
				if ( modal.classList.contains( MODAL_OPEN_CLASS ) ) {
					this.closeModal( modal );
				}
			}
		}

		handleEscapeKey( event ) {
			if ( event.key === 'Escape' && this.activeModals.size > 0 ) {
				const modals = Array.from( this.activeModals );
				const lastModal = modals[ modals.length - 1 ];
				this.closeModal( lastModal );
			}
		}

		openModal( modalId ) {
			const modal = document.getElementById(
				'wps-blocks-modal-' + modalId
			);
			if ( ! modal ) {
				// eslint-disable-next-line no-console
				console.warn( 'wps-blocks modal not found:', modalId );
				return;
			}

			modal.classList.add( MODAL_OPEN_CLASS );
			modal.setAttribute( 'aria-hidden', 'false' );
			this.activeModals.add( modal );

			if ( this.activeModals.size === 1 ) {
				this.lockBody();
			}

			const firstFocusable = modal.querySelector(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			if ( firstFocusable ) {
				setTimeout( () => firstFocusable.focus(), 100 );
			}
		}

		closeModal( modal ) {
			if ( ! modal || ! modal.classList.contains( MODAL_OPEN_CLASS ) ) {
				return;
			}

			modal.classList.remove( MODAL_OPEN_CLASS );
			modal.setAttribute( 'aria-hidden', 'true' );
			this.activeModals.delete( modal );

			if ( this.activeModals.size === 0 ) {
				this.unlockBody();
			}
		}

		closeAllModals() {
			this.activeModals.forEach( ( modal ) => {
				modal.classList.remove( MODAL_OPEN_CLASS );
				modal.setAttribute( 'aria-hidden', 'true' );
			} );
			this.activeModals.clear();
			this.unlockBody();
		}

		lockBody() {
			document.body.classList.add( BODY_LOCK_CLASS );
		}

		unlockBody() {
			document.body.classList.remove( BODY_LOCK_CLASS );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', () => {
			window.wpsBlocksModalManager = new WpsBlocksModalManager();
		} );
	} else {
		window.wpsBlocksModalManager = new WpsBlocksModalManager();
	}
} )();
